<template>
  <div class="documents-list">
    <doctype-sidesheet ref="modal" @update="reload" @remove-group="onGroupRemove"></doctype-sidesheet>
    <u-confirm id="delete-doctype" ref="confirm" />

    <c-loader v-if="loading" label="" :active="loading" height="500" />

    <div v-if="!loading">
      <div v-if="hasVisibleItems">
        <draggable
          v-model="documents"
          tag="div"
          ghost-class="sortable__ghost"
          class="item-container"
          group="list"
          :move="onMove"
          :force-fallback="true"
          @change="resortDocuments"
        >
          <div
            v-for="document in documents"
            :key="document.type + document.id"
            class="item-group"
            :data-type="document.type"
          >
            <div v-if="document.type === 'group' && isDocumentVisible(document)">
              <documents-group
                :group="document"
                :query="normalizedQuery"
                :selected-tab="selectedTab"
                @edit-group="onGroupEdit"
                @remove-group="onGroupRemove"
                @remove-document="onDocumentRemove"
                @resort="resortDocuments"
                @add-document="onDocumentAddToGroup"
                @move="onDocumentMove"
                @archiveGroup="onGroupArchive"
                @archiveDocument="onDocumentArchive"
              ></documents-group>
            </div>
            <div v-else-if="document.type === 'without-group' && isDocumentVisible(document)">
              <documents-group
                :fake="true"
                :group="document"
                :query="normalizedQuery"
                :selected-tab="selectedTab"
                @edit-group="onGroupEdit"
                @remove-group="onGroupRemove"
                @remove-document="onDocumentRemove"
                @resort="resortDocuments"
                @add-document="onDocumentAddToGroup"
                @move="onDocumentMove"
                @archiveDocument="onDocumentArchive"
              ></documents-group>
            </div>
          </div>
        </draggable>
      </div>
      <div v-else class="documents-list__empty">Ничего не найдено. Попробуйте изменить параметры поиска.</div>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable";

import Loader from "@/components/loader";
import DoctypeSidesheet from "@/pages/documents/doctype-sidesheet";
import DocumentsGroup from "./documents-group";
import Confirm from "./u-confirm";

export default {
  name: "documents-list",
  components: {
    draggable,
    "documents-group": DocumentsGroup,
    "doctype-sidesheet": DoctypeSidesheet,
    "u-confirm": Confirm,
    "c-loader": Loader,
  },

  props: ["query", "selectedTab"],
  data: () => ({
    documents: [],
    loading: true,
    hasVisibleItems: true,
  }),
  computed: {
    normalizedQuery() {
      return this.query.trim().toLowerCase();
    },
  },

  watch: {
    query() {
      this.hasVisibleItems = this.documents.some((d) => {
        if (d.type !== "without-group") return this.isDocumentVisible(d);

        return d.docs.some((doc) => this.isDocumentVisible(doc));
      });
    },
    selectedTab() {
      this.loadDocuments();
    }
  },

  created() {
    this.loadDocuments();
  },

  methods: {
    loadDocuments() {
      this.loading = true;
      this.$store.dispatch("documents/loadDocuments",{is_archive: this.selectedTab}).then((documents) => {
        this.documents = [
          ...documents.filter((d) => d.type === "group"),
          {
            type: "without-group",
            docs: documents.filter((d) => d.type !== "group"),
          },
        ];
        this.loading = false;
      });
    },

    isDocumentVisible(document) {
      if (!this.normalizedQuery) return true;
      if (document.type === "without-group") return true;
      if (document.name.toLowerCase().includes(this.normalizedQuery)) return true;

      if (document.type === "group") {
        return document.docs.some((doc) => this.isDocumentVisible(doc));
      }
      return true;
    },

    onMove(evt) {
      return !(evt.dragged.dataset.type === "group" && evt.to.classList.contains("item-sub"));
    },

    onDocumentAddToGroup({ group, document }) {
      this.$store.dispatch("documents/moveDocument", {
        id: document.id,
        typeId: group.id,
      });
    },

    onDocumentMove(event) {
      console.info("move", event);
    },

    resortDocuments() {
      const list = [];
      this.documents.forEach((group) => {
        if (group.type === "group") {
          const item = {
            id: group.id,
            type: "group",
            sort: list.length,
          };
          list.push(item);
        }

        group.docs.forEach((doc) => {
          const item = {
            id: doc.id,
            type: "document",
            sort: list.length,
          };
          list.push(item);
        });
      });
      this.$store.dispatch("documents/resort", { list });
    },

    addGroup() {
      this.$refs.modal.open(null);
    },

    onGroupEdit({ group }) {
      this.$refs.modal.open({ doctype: group });
    },

    onDocumentRemove({ document, group }) {
      this.$refs.confirm.open(
        {
          title: "Удаление документа",
          text: `Документ <b>${document.name}</b> будет удалён без возможности восстановления`,
        },
        () => {
          this.$store.dispatch("documents/removeDocument", { id: document.id });
          group.docs = group.docs.filter((d) => d !== document);
        },
      );
    },

    onDocumentArchive({document, group}) {
      this.$refs.confirm.open(
        {
          title: Number(this.selectedTab) === 0 ? "Перенос документа в архив" : "Перенос документа из архива",
          confirmText: "Перенести",
          text: Number(this.selectedTab) === 0 ? `Документ <b>${document.name}</b> будет перенесен в архив` : `Документ <b>${document.name}</b> будет перенесен из архива`,
        },
        () => {
          this.$store.dispatch("documents/archiveDocument", { id: document.id })
            .then((res) => {
              this.showPopupMessage(res.message, res.success);

              this.documents = this.documents.map((groupInitial) => {
                if (groupInitial.type === "group" && groupInitial.id === group.id) {
                  groupInitial.docs = groupInitial.docs.filter((d) => d.id !== document.id);
                }
                if(group.type === "without-group") {
                  groupInitial.docs = groupInitial.docs.filter((d) => d.id !== document.id);
                }
                return groupInitial;
              });
            });
        },
      );
    },

    onGroupRemove({ group }, fromSidesheet) {
      this.$refs.confirm.open(
        {
          title: "Удаление типа документа",
          text: `Тип документа <b>${group.name}</b> будет удалён без возможности восстановления`,
        },
        () => {
          this.$store
            .dispatch("documents/removeDocumentType", {
              id: group.id,
            })
            .then(() => {
              this.documents = this.documents.filter((d) => d !== group);
              if (fromSidesheet) {
                this.$refs.modal.close();
              }
            });
        },
      );
    },

    onGroupArchive({group}) {
      this.$refs.confirm.open(
        {
          title: Number(this.selectedTab) === 0 ? "Перенос группы в архив" : "Перенос группы из архива",
          confirmText: "Перенести",
          text: Number(this.selectedTab) === 0 ? `Группа <b>${group.name}</b> будет перенесен в архив` : `Группа <b>${group.name}</b> будет перенесен из архива`,
        },
        () => {
          this.$store.dispatch("documents/archiveGroup", { id: group.id })
            .then((res)=>{
              this.showPopupMessage(res.message, res.success);
              this.documents = this.documents.filter((d) => d.id !== group.id);
            });
        },
      );
    },

    reload() {
      this.loadDocuments();
    },

    showPopupMessage(message, success) {
      this.$notify({
        group: success ? "success-message" : "error-message",
        data: {
          textMessage: message,
        },
      });
    }
  },
};
</script>

<style lang="scss">
@import "~@/assets/styles/vars";
.documents-list {
  max-width: 1190px;

  .item-group {
  }
  .item-group + .item-group {
    margin-top: -1px;
  }

  .item-group[data-type="group"] .item-group[data-type="document"]:first-child {
    margin-top: -1px;
  }

  &__empty {
    color: $color-label;
    margin-top: 30px;
    font-size: 15px;
    @include onlyExtraSmall {
      margin-top: 0;
      padding: 0 20px;
    }
  }

  .sortable__ghost {
    height: 5px;
    overflow: hidden;
    background: $color-primary;
    opacity: 1;
    width: inherit !important;

    * {
      display: none;
    }
  }

  .sortable-drag {
    min-height: 38px !important;
    z-index: 10 !important;
    opacity: 1 !important;
    background: white !important;
    border-bottom: none !important;
    box-shadow: 0px 3px 16px rgba(0, 102, 255, 0.7) !important;

    *:not(.toggle-button) {
      border: none;
    }

    &[data-type="group"] {
      min-height: 50px !important;
      overflow: hidden;
    }
  }
}
</style>
